module.exports = __webpack_public_path__ + "img/mgh-otemachi.ae4d6990.jpg";